import AddGoodReview from './mutation'
export default AddGoodReview
